import ProfileDropdown from "./ProfileDropdown";

const TopNav = ({ currentPageInfo }) => {
  return (
    <div className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-x-4 border-b border-ink-100 bg-cream-50/95 backdrop-blur px-4 sm:gap-x-6 sm:px-6 lg:px-8">
      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="flex flex-1 items-center">
          <div className="flex items-center gap-x-2">
            <h1 className="font-display text-xl text-ink-900 tracking-display">
              {currentPageInfo.title}
            </h1>
            {currentPageInfo.subtitle && (
              <>
                <span className="text-ink-300" aria-hidden="true">/</span>
                <span className="font-display text-xl text-ink-500">
                  {currentPageInfo.subtitle}
                </span>
              </>
            )}
          </div>
        </div>

        <div className="flex items-center gap-x-4 lg:gap-x-6">
          <ProfileDropdown />
        </div>
      </div>
    </div>
  );
};

export default TopNav;
